import { useEffect, useState } from "react";
import { useApp } from "../store.jsx";
import { getPlans } from "../lib/api";
import { Icon } from "./Common.jsx";
import { useSession } from "../lib/auth-client";

// Persistent banner shown above page content.
// States:
//   red  — trial expired (Company.isActive=false) or subscription past_due
//   orange — trial ends in 1 day
//   yellow — trial ends in 2-3 days
//   null   — otherwise (no banner)
export function TrialBanner() {
  const { goPage } = useApp();
  const { data: session } = useSession();
  const [current, setCurrent] = useState(null);

  useEffect(() => {
    if (session?.user?.role === "admin") return;
    let cancelled = false;
    getPlans()
      .then((d) => {
        if (!cancelled) setCurrent(d.current || null);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [session]);

  if (!current) return null;

  const { isActive, trial, subscription } = current;

  // Trial expired / company deactivated — red, non-dismissible
  if (isActive === false) {
    return (
      <Banner color="#dc2626" icon="alert-triangle" cta="Choose Plan" onCta={() => goPage("billing")}>
        <strong>Your trial has ended.</strong> Choose a plan to keep your workspace active.
      </Banner>
    );
  }

  // Subscription past_due
  if (subscription?.status === "past_due") {
    return (
      <Banner color="#dc2626" icon="alert-triangle" cta="Update Payment" onCta={() => goPage("billing")}>
        <strong>Payment failed.</strong> Update your payment method within 3 days to avoid disruption.
      </Banner>
    );
  }

  // Trial ending soon (≤3 days, >0)
  if (trial && trial.remainingDays > 0 && trial.remainingDays <= 3) {
    const color = trial.remainingDays === 1 ? "#ea580c" : "#ca8a04";
    return (
      <Banner color={color} icon="clock" cta="Upgrade Now" onCta={() => goPage("billing")}>
        Your free trial ends in{" "}
        <strong>
          {trial.remainingDays} day{trial.remainingDays === 1 ? "" : "s"}
        </strong>
        .
      </Banner>
    );
  }

  return null;
}

function Banner({ color, icon, children, cta, onCta }) {
  return (
    <div
      style={{
        background: color,
        color: "#fff",
        padding: "10px 18px",
        display: "flex",
        alignItems: "center",
        gap: 10,
        fontSize: 14,
      }}
    >
      <Icon name={icon} size={16} />
      <span>{children}</span>
      <button
        onClick={onCta}
        style={{
          marginLeft: "auto",
          background: "rgba(255,255,255,.2)",
          color: "#fff",
          border: "1px solid rgba(255,255,255,.35)",
          padding: "6px 12px",
          borderRadius: 6,
          fontSize: 13,
          fontWeight: 600,
          cursor: "pointer",
        }}
      >
        {cta}
      </button>
    </div>
  );
}
